import React, { useMemo, useCallback, memo } from 'react';
import { parseAnswer } from './AnswerParser';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { fetchCitationContent } from '../../store/citationSlice';
import "./Citations.css";
import { AskResponse, Citation } from '../../types/AppTypes';

interface Props {
    answer: AskResponse;
    onSpeak?: any;
    isActive?: boolean;
    index: number;
}

const Citations = memo(({ answer, index }: Props) => {
    
    const dispatch = useAppDispatch();
    const selectedConversationId = useAppSelector((state) => state.app.selectedConversationId);
    const generatedConversationId = useAppSelector((state) => state.app.generatedConversationId);
    const conversationId = selectedConversationId || generatedConversationId || "default";
    const parsedAnswer = useMemo(() => parseAnswer(answer), [answer]);
    const createCitationFilepath = (
        citation: Citation,
        index: number,
        truncate: boolean = false
    ) => {
        return citation.id || citation.source || citation.title || `Citation ${index}`;
    };

    const onCitationClicked = useCallback(async (
        citation: Citation
    ) => {
        dispatch(fetchCitationContent({ citation, conversationId }));
    }, [dispatch, conversationId]);


    return (
        <div
            style={{
                marginTop: 8,
                display: "flex",
                flexDirection: "column",
                height: "100%",
                gap: "4px",
                maxWidth: "100%",
            }}
        >
            {parsedAnswer.citations.map((citation, idx) => {
                return (
                    <span
                        role="button"
                        onKeyDown={(e) =>
                            e.key === " " || e.key === "Enter"
                                ? onCitationClicked(citation)
                                : () => { }
                        }
                        tabIndex={0}
                        title={createCitationFilepath(citation, ++idx)}
                        key={idx}
                        onClick={() => onCitationClicked(citation)}
                     className={"citationContainer"}
                    >
                        <div
                             className={"citation"} 
                            key={idx}>
                            {idx}
                        </div>
                        {createCitationFilepath(citation, idx, true)}
                    </span>
                );
            })}
        </div>)
});

Citations.displayName = 'Citations';

export default Citations;